var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.verifyAddress
        ? _c("verify-address", {
            attrs: {
              "default-address": _vm.defaultAddress,
              "default-city": _vm.defaultCity,
              "default-state": _vm.defaultState,
              "staff-override": _vm.showStaffTools,
              addItemObj: _vm.addItemObj,
              mapCenterLat: _vm.mapCenterLat,
              mapCenterLng: _vm.mapCenterLng,
              restZone: _vm.restZone,
              restName: _vm.restInfoBanner.name,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-wrapper" },
        [
          _vm.blockedMessage
            ? _c(
                "div",
                { domProps: { innerHTML: _vm._s(_vm.blockedMessage) } },
                [_vm._v("\n      " + _vm._s(_vm.blockedMessage) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.closedMessage
            ? _c(
                "div",
                { domProps: { innerHTML: _vm._s(_vm.closedMessage) } },
                [_vm._v("\n      " + _vm._s(_vm.closedMessage) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("rest-info-modal", {
            attrs: {
              showModal: _vm.infoOpen,
              title: _vm.restInfoModal.title,
              street: _vm.restInfoModal.street,
              cityStZip: _vm.restInfoModal.cityStZip,
              phone: _vm.restInfoModal.phone,
              restHours: _vm.restInfoModal.restHours,
              logo: _vm.restInfoModal.logo,
              map: _vm.restInfoModal.map,
              restColor: _vm.restColor,
            },
            on: { "close-modal": _vm.closeInfo },
          }),
          _vm._v(" "),
          _vm.showLaterOrder
            ? _c("later-order-modal", {
                attrs: {
                  restId: _vm.restId,
                  hours: _vm.restInfoModal.restAndMenuHours,
                  restName: _vm.restInfoBanner.name,
                },
                on: {
                  goToMenu: function ($event) {
                    return _vm.hideLaterOrderModal()
                  },
                  hideModal: _vm.hideLaterOrderModal,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.addItemOpen
            ? _c("add-item-modal", {
                attrs: {
                  showAddItem: _vm.addItemOpen,
                  restId: _vm.restId,
                  restName: _vm.restInfoBanner.name,
                  showVerifyAddress: _vm.showVerifyAddress,
                },
                on: {
                  "close-modal": _vm.closeAddItem,
                  getAddress: _vm.handleGetAddress,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.editItemOpen
            ? _c("edit-item-modal", {
                attrs: {
                  showEditItem: _vm.editItemOpen,
                  restId: _vm.restId,
                  restName: _vm.restInfoBanner.name,
                  showVerifyAddress: _vm.showVerifyAddress,
                },
                on: {
                  "close-modal": _vm.closeEditItem,
                  getAddress: _vm.handleGetAddress,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showAlert
            ? _c("page-banner", {
                attrs: {
                  title: _vm.pageBanner.title,
                  copy: _vm.pageBanner.copy,
                  url: _vm.pageBanner.url,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("menu-hero", {
            attrs: {
              backgroundImage: _vm.menuHero.backgroundImage,
              restLogo: _vm.menuHero.restLogo,
            },
          }),
          _vm._v(" "),
          _c("rest-info-banner", {
            attrs: {
              name: _vm.restInfoBanner.name,
              tags: _vm.restInfoBanner.tags,
              isPartner: _vm.restInfoBanner.isPartner,
              nonPartnerMessage: _vm.restInfoBanner.nonPartnerMessage,
              deliveryCost: _vm.restInfoBanner.deliveryCost,
              distance: _vm.restInfoBanner.distance,
              deliveryTime: _vm.deliveryTime,
              waitTime: _vm.restInfoBanner.waitTime,
              restColor: _vm.restColor,
              cityName: _vm.restInfoBanner.cityName,
              showMenuEditLink: _vm.restInfoBanner.showMenuEditLink,
              restId: _vm.restId,
            },
            on: {
              showInfo: _vm.openInfo,
              showDelTime: _vm.showLaterOrderModal,
              deliveryASAP: _vm.setDeliveryASAP,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sticky-wrapper",
              attrs: { id: "menu-tabs-section" },
            },
            [
              _c("menu-type-tabs", {
                attrs: {
                  menuTypes: _vm.menuTypesObject,
                  restColor: _vm.restColor,
                },
                on: { "handle-menu-switch": _vm.menuSwitch },
              }),
              _vm._v(" "),
              _c("menu-categories", {
                attrs: {
                  categories: _vm.currentCategories,
                  cartCount: _vm.cartCount,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("menu-allergy-filter", {
            attrs: {
              allergyFilters: _vm.currentAllergyFilters,
              selectedAllergyFilters: _vm.selectedAllergyFilters,
            },
            on: { filterSelected: _vm.filterMenuByAllergy },
          }),
          _vm._v(" "),
          _vm.showSpecialItem
            ? _c("add-special-item", {
                attrs: {
                  restId: _vm.restId,
                  restName: _vm.restInfoBanner.name,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.currentMenuCardList, function (menuCardList) {
            return _c("menu-card-list", {
              key: menuCardList.id,
              attrs: {
                restId: _vm.restId,
                id: menuCardList.id,
                title: menuCardList.title,
                description: menuCardList.description,
                cards: menuCardList.cards,
              },
              on: { showAddItemModal: _vm.openCurrentItem },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }